exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".collaborator-table{-webkit-box-shadow:0 0 16px 0 rgba(0,0,0,.05);box-shadow:0 0 16px 0 rgba(0,0,0,.05)}", "", {"version":3,"sources":["/app/src/components/Submission/steps/CollaboratorDetails/CollaboratorItem/CollaboratorTable.vue"],"names":[],"mappings":"AACA,oBACE,8CAAsD,AAC9C,qCAA8C,CACvD","file":"CollaboratorTable.vue","sourcesContent":["\n.collaborator-table {\n  -webkit-box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.05);\n          box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.05);\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0bf0aa3e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Submission/steps/CollaboratorDetails/CollaboratorItem/CollaboratorTable.vue
// module id = 549
// module chunks = 0 1 2 3 9